import React from 'react';
import getConfig from 'next/config';
import { Menu } from '@cvent/carina/components/Menu';
import { ChevronDownIcon } from '@cvent/carina/components/Icon';
import { Row } from '@cvent/carina/components/Row';
import { Col } from '@cvent/carina/components/Col';
import { useTranslate } from 'nucleus-text';

import { Regions } from '@data/Regions';
import { useFooterStyle } from '@hooks/style/useFooterStyle';
import { TextLink } from '@cvent/carina/components/TextLink';
import { useBreakpoints } from '@cvent/carina/components/Breakpoints';
import { useCustomBreakpoints } from '@hooks/display/useCustomBreakpoints';

type RegionSelectorDropdownProps = {
  testID: string;
};

const { publicRuntimeConfig } = getConfig();
export const RegionMenu = ({ testID }: RegionSelectorDropdownProps): JSX.Element => {
  const breakpoints = useBreakpoints();
  const { isMobile } = useCustomBreakpoints(breakpoints);
  const { translate } = useTranslate();
  const { footerButton } = useFooterStyle();
  const currentPod = publicRuntimeConfig.POD;

  /**
   * Short circuit display when both regions are not set.
   */
  if (Regions.US.hostname === '' || Regions.EU.hostname === '') return null;

  const regionOptions = Object.entries(Regions).map(([id, reg]) => {
    return { label: translate(reg.translation), value: id };
  });

  const onRegionSelect = ({ value }) => {
    if (value !== currentPod) {
      const url = new URL(location.href);
      url.host = `${Regions[value].hostname}:443`;

      window.location.replace(url);
    }
  };

  return (
    <Menu
      testID={`${testID}_regionMenu`}
      placement={isMobile ? 'bottom' : 'right'}
      options={regionOptions}
      selected={currentPod}
      onSelect={onRegionSelect}
      trigger={(handlePress): JSX.Element => (
        <TextLink onClick={handlePress} neutral target="_blank" testID={`${testID}_regionButton`} css={footerButton}>
          <Row>
            <Col width={'content'} padding={0}>
              {translate(Regions[currentPod].translation)}
              <ChevronDownIcon />
            </Col>
          </Row>
        </TextLink>
      )}
    />
  );
};
